export default {
	methods: {
		errorModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 9000,
				headerClass: "danger-toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
			this.toasttext = "";
		},
		successModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
			this.toasttext = "";
		},
		downloadingModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "loader-toast-headerclass",
				bodyClass: "toast-height-0",
				toastClass: "",
			});
			this.toasttext = "";
		},
		warningModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "warning-toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
			this.toasttext = "";
		},
		bookMarkModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "bookmark-toast-headerclass",
				bodyClass: "toast-height-0",
				toastClass: "",
			});
			this.toasttext = "";
		},
		noBookMarkModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "nobookmark-toast-headerclass",
				bodyClass: "toast-height-0",
				toastClass: "",
			});
			this.toasttext = "";
		},
		lessDelaywarningModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 2000,
				headerClass: "warning-toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
			this.toasttext = "";
		},
	},
};
